





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiCepFormat from '@/components/UI/cep-format.vue';
import { getPatientAvailableAddressesUnit } from '@/services/patients';

@Component({
  components: { PermissionAuth, UiCepFormat },
})
export default class PatientAddress extends BaseComponent {
  @Prop()
  public item!: any;

  @Prop()
  public idUnit!: any;

  @Prop({default: false})
  public disabled: boolean;

  public addressList: any[] = [];
  public idsAddressList: any[] = [];
  loading = false;

  public rules: any[] = [
    (v) => this.isOk() || 'Selecione ao menos 1 endereço',
  ];

  public tableHeaders: any = [
    { text: '', value: 'actions', align: 'center', sortable: false, width: 50 },
    { text: 'Descrição', value: 'descricao', sortable: true, width: 100 },
    { text: 'Endereço', value: 'endereco', sortable: false },
  ];

  isOk() {
    let ok = !this.item.ativo || this.disabled || this.idsAddressList.some(id => this.item.enderecos.some(e => e.id == id));
    this.$emit('valid', ok);
    return ok;
  }

  @Watch('idUnit', {immediate: true})
  public onChangeIdUnit(idUnit): void {
    this.loading = true;
    getPatientAvailableAddressesUnit(this.idUnit).subscribe(res => {
      /*this.item.enderecos = this.item.enderecos || [];
      this.item.enderecos = res.filter((item) => {
        let v = this.item.enderecos.some((address) => address.id == item.id);
        return v;
      });*/
      this.addressList = res;
      this.idsAddressList = this.addressList.map(e => e.id);
      this.loading = false;
    }, error => {
      this.showToastApiError(error);
      this.loading = false;
    });
  }
}
